// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"372":"ab59c38e","791":"7231a7c1"}[chunkId] + ".chunk.css";
};